import { faInfo, faExclamation } from '@fortawesome/pro-solid-svg-icons';

import Tooltip from '@mui/material/Tooltip';

import { FontAwesomeSvgIcon } from 'components/shared';

type Props = {
  warning?: boolean;
  message: string;
};

export default function InfoCell({ warning, message = '' }: Props) {
  return (
    <td className="info-cell">
      <Tooltip title={message} arrow disableInteractive>
        <FontAwesomeSvgIcon
          icon={warning ? faExclamation : faInfo}
          fontSize="small"
          color={warning ? 'warning' : 'primary'}
          className="info-icon"
        />
      </Tooltip>
    </td>
  );
}
